<div class="root-container">
  @for (i of items();track i){
    <div [class]="['item',i.style]">
      @switch (i.style){
        @case ('success'){
          <i class="fa-solid fa-circle-check type-icon"></i>
        }
        @case ('warning'){
          <i class="fa-solid fa-circle-exclamation type-icon"></i>
        }
        @case ('error'){
          <i class="fa-solid fa-circle-xmark type-icon"></i>
        }
        @case ('info'){
          <i class="fa-solid fa-circle-info type-icon"></i>
        }
        @case ('loading'){
          <spinner [default]="false" [size]="30" />
        }
      }
      <div class="item-body">
        <div class="item-style">{{ i.style | titlecase }}</div>
        <div class="item-message">
           {{ i.message }}
          @if(i.type == 'timed'){
            ({{ ((i.time - i.elapsed )/ 1000) }})
          }
        </div>
      </div>
      <i class="fa-solid fa-xmark close" (click)="toast.removeToast(i)"></i>
    </div>
  }
</div>
